const _strings = {
  'katal-radiobutton-group-aria-tooltip-trigger': {
    'en-US': 'Additional information',
  },
};

export default _strings;
